<template>
  <div>
    <div class="header">
      <h1>Lawn Treatment Service</h1>
      <p>
        <span>{{ price }} </span> per service
      </p>
    </div>
    <div class="content">
      <h2 class="block">Request first treatment</h2>
      <p class="block">
        Your first treatment will be confirmed and serviced within a three week window.
      </p>
      <p class="block">
        Each service will be scheduled about 4-6 weeks apart. Check in-app for the next service.
      </p>
    </div>
    <div class="has-text-centered">
      <LsButton
        text="Schedule Service"
        track-id="add_lawn_treatment-submit_request"
        :is-uppercase="false"
        bg-color="primary"
        class="submit-request"
        @click.once="$emit('submitRequest')"
      />
      <br />
      <span class="not-charged-span"> You are not charged until the service is completed. </span>
    </div>
  </div>
</template>

<script>
import LsButton from '@/components/common/LsButton/LsButton.vue';
import VueTypes from 'vue-types';

export default {
  name: 'LawnTreatmentWhenViewComponent',
  components: { LsButton },
  props: {
    price: VueTypes.string.isRequired,
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding-bottom: 15px;

  h1,
  span {
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 1.8rem;
    margin-bottom: 15px;
    color: $primary;
  }
}

.content {
  border-top: 1px solid #d8f3e6;
  margin-bottom: 40px;

  h2 {
    font-size: 18px;
    font-weight: bold;
    margin: 32px 0 10px 0;
    line-height: 28px;
  }

  p {
    font-size: 14px;
  }
}

.submit-request {
  margin-bottom: 18px;
  min-width: 272px;
  height: 40px;
}

.not-charged-span {
  font-size: 13px;
  text-align: justify;
}
</style>
